module.exports = __webpack_public_path__ + "static/img/LOGO.a12cb71a.png";